import React, { useState, useContext } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { AuthContext } from "../context/authContext";

const WritePicture = () => {
  const { currentUser } = useContext(AuthContext);
  const [file, setFile] = useState(null);
  const [caption, setCaption] = useState("");
  const navigate = useNavigate();

  const upload = async () => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      const res = await axios.post("/api/upload", formData);
      return res.data;
    } catch (err) {
      console.log(err);
    }
  };

  const handleClick = async (e) => {
    e.preventDefault();
    if (!file) return;

    try {
      const imgUrl = await upload();

      await axios.post("/api/pictures", {
        img: imgUrl,
        caption,
        date: moment(Date.now()).format("YYYY-MM-DD HH:mm:ss"),
      });

      navigate("/pictures");
    } catch (err) {
      console.log(err);
    }
  };

  if (currentUser?.username !== "emma20106") {
    return (
      <div className="add-picture">
        <h2>Sorry, only the blog owner can upload pictures!</h2>
      </div>
    );
  }

  return (
    <div className="add-picture">
      <h1>Upload a picture</h1>
      <input
        type="file"
        id="file"
        onChange={(e) => setFile(e.target.files[0])}
      />
      <textarea
        placeholder="Add a caption (optional)"
        value={caption}
        onChange={(e) => setCaption(e.target.value)}
      />
      <button onClick={handleClick}>Publish</button>
    </div>
  );
};

export default WritePicture;
